/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* Licensed under the MIT License. See LICENSE.md in the project root for license terms.
*--------------------------------------------------------------------------------------------*/

import { editor, IRange } from "monaco-editor/esm/vs/editor/editor.api";
import ts from "typescript";

export abstract class Adapter {
  protected _textSpanToRange(model: editor.ITextModel, span: ts.TextSpan): IRange {
    const p1 = model.getPositionAt(span.start);
    const p2 = model.getPositionAt(span.start + span.length);
    const { lineNumber: startLineNumber, column: startColumn } = p1;
    const { lineNumber: endLineNumber, column: endColumn } = p2;
    return { startLineNumber, startColumn, endLineNumber, endColumn };
  }
}